var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBergbau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bergbau__Icn/40px/Legende/Bergbau",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Bergbau__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Bergbau__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Legende_Bergbau__Rectangle",
    transform: "rotate(45 20 20)",
    d: "M14 14H26V26H14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergbau);
export default __webpack_public_path__ + "static/media/Bergbau.71aa84fd316620f61d92d6967c16c951.svg";
export { ForwardRef as ReactComponent };